import { getApiBaseUrl } from './api';

const FALLBACK_PUBLIC_ORIGIN = 'https://foi-sn.mmebov.org';

function getPublicOrigin() {
  const apiBaseUrl = getApiBaseUrl();

  if (!apiBaseUrl) {
    return FALLBACK_PUBLIC_ORIGIN;
  }

  return apiBaseUrl.replace(/\/api\/?$/, '');
}

export function normalizeRemoteMediaUrl(value?: string | null, fallback?: string) {
  if (!value) {
    return fallback ?? '';
  }

  const normalized = value.trim();

  if (
    normalized.startsWith('blob:') ||
    normalized.startsWith('data:') ||
    normalized.startsWith('file:')
  ) {
    return fallback ?? '';
  }

  if (normalized.startsWith('/')) {
    return `${getPublicOrigin()}${normalized}`;
  }

  if (/^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?\//i.test(normalized)) {
    const path = normalized.replace(/^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?/i, '');
    return `${getPublicOrigin()}${path}`;
  }

  return normalized;
}
